import { Injectable, inject } from '@angular/core';

import { Competition, Region } from '@cds/betting-offer/tags';
import { LeagueModel, RegionModel } from '@frontend/sports/betting-offer/feature/model';
import { RegionsConfig } from '@frontend/sports/common/client-config-data-access';
import { Nullable } from '@frontend/sports/common/core/utils/extended-types';

@Injectable({
    providedIn: 'root',
})
export class RegionVisibilityService {
    private regionsConfig = inject(RegionsConfig);

    shouldHide(region: Nullable<Region | RegionModel>, league: Nullable<LeagueModel | Competition>): boolean {
        if (region && league) {
            const shouldHideRegion = this.regionsConfig.listOfRegionsToHideRegionName.includes(region.id);
            const shouldHideRegionForLeague = this.regionsConfig.listOfLeaguesToHideRegionName.includes(league.id);

            return shouldHideRegion && shouldHideRegionForLeague;
        }

        return false;
    }
}
